/** @param {Any[]} arr */
export function clearArray(arr) {
  if (!arr) {
    console.error("Argument is null!");
    return;
  }
  arr.length = 0;
}
export function clearObject(obj) {
  Object.keys(obj).forEach((x) => delete obj[x]);
}

/**
 *
 * @param {[]} results
 * @returns
 */
export function aggregateResponses(results) {
  if (!results?.at(0)) return {
    ok: true,
    errorsOrDefault: ["Cannot aggregate empty response array"],
    value: { data: [], count: 0 }
  };

  return results.reduce(
    (r, x) => {
      r.ok = r.ok && (x?.ok || false);
      if (x?.ok || false) {
        if (x.value?.data && x.value.data.constructor === Array) {
          r.value.data.splice(0, 0, ...x.value.data);
          r.value.count += x.value?.count || 0;
        }
        else {
          r.value.data.splice(0,0,x.value);
          r.value.count++;
        }
      } else {
        r.message ??= "";
        r.message += x.message && r.message !== x.message ? x.message + "\n" : "";
        r.errorsOrDefault ??= [];
        r.errorsOrDefault.push(...(x.errorsOrDefault || []));
      }
      return r;
    },
    { ok: true, errorsOrDefault: [], value: { data: [], count: 0 } }
  );
}
export function parseErrorOrDefault(errorOrDefault) {
  if (errorOrDefault.constructor === Array) {
    return errorOrDefault.join(",");
  } else if (errorOrDefault.constructor === Object) {
    return JSON.stringify(errorOrDefault);
  } else return errorOrDefault;
}

export function addOrUpdateFrom(arr, newarr, selector, updFunc = Object.assign) {
  newarr.forEach((newitem) => {
    addOrUpdate(arr, newitem, selector, updFunc);
  });
}
export function addOrUpdate(arr, newitem, selector, updFunc = Object.assign) {
  let exitem = arr.find((x) => selector(x) === selector(newitem));
  if (exitem) {
    updFunc(exitem, newitem);
    return exitem;
  } else {
    arr.push(newitem);
    return newitem;
  }
}
export function removeFrom(arr, item, selector) {
  let i = arr.findIndex((x) => selector(x) === selector(item));
  if (i && i > -1) arr.splice(i, 1);
}
export function shortenRateString(rate) {
  let neg = rate < 0;
  rate = Math.abs(rate);

  let s = ["", "k", "m", "b", "t"];

  if (rate < 1000) return neg ? -1 * rate : rate;

  let dig = Math.floor(("" + rate).length / 3);

  let short = parseFloat((dig != 0 ? rate / Math.pow(1000, dig) : rate).toPrecision(2));

  if (short % 1 != 0) {
    short = short.toFixed(1);
  }

  short = neg ? -1 * short : short;

  return short + s[dig];
}
export function roundTo(num, prec) {
  let div = Math.pow(10, prec || 0);
  return Math.round((num + Number.EPSILON) * div) / div;
}

/**
 *  @param { Map } map
 * */
export function clearMap(map) {
  for (let key of map.keys()) {
    map.delete(key);
  }
}

export function asyncTimeout(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

/**
 * @param {[]} array
 * @param {Number} chunkSize
 * @returns {[]}
 */
export function chunks(array, chunkSize) {
  if (chunkSize === 0) return array;
  let chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    const chunk = array.slice(i, i + chunkSize);
    chunks.push(chunk);
  }
  return chunks;
}

export function minBy(arr, pluck) {
  return arr.reduce((min, x) => (min && pluck(min) <= pluck(x) ? min : x), null);
}
export function maxBy(arr, pluck) {
  return arr.reduce((max, x) => (max && pluck(max) >= pluck(x) ? max : x), null);
}
